import { useTranslation } from 'react-i18next';
import { useLoaderData } from '@tanstack/react-router';
import Section from '@/components/layout/section.tsx';

export default function MobileApp() {
	const { t } = useTranslation();

	const data = useLoaderData({ from: '__root__' });

	return (
		<Section className="flex items-center ">
			<Section className="flex  block-gradient  z-2 rounded-xl overflow-hidden relative !pl-0 !pt-0 max-sm:!pl-4 max-sm:!pt-4">
				<div className="mobile-app-overlay w-[50%] max-lg:w-[100%] max-md:w-full h-full aspect-[16/10] absolute max-sm:hidden">
					<img
						src={data?.bannerPhotoUrl}
						alt={t('mobile_app.title')}
						className="w-full h-full object-cover"
					/>
				</div>

				<div className="w-[50%] max-lg:hidden" />

				<div className="w-[50%] max-lg:w-full pl-6 max-md:pl-0 py-26 max-xl:py-14 max-md:py-12 z-2">
					<div className="flex flex-col gap-4 max-sm:gap-2">
						<h2 className="text-end text-6xl max-2xl:text-5xl max-xl:text-4xl max-md:text-3xl text-white font-bold">
							{data?.bannerTitle}
						</h2>

						<p className="text-white text-end text-2xl max-2xl:text-xl max-xl:text-lg leading-10 max-2xl:leading-8 max-xl:leading-7 max-md:text-lg whitespace-break-spaces">
							{data?.bannerDescription}
						</p>
					</div>

					<div className="flex items-center justify-end gap-6">
						{data?.bannerButtons?.map((item: any, i: number) => (
							<a
								key={`banner-button-${i}`}
								href={item?.url}
								target="_blank"
								className="relative flex justify-end h-[84px] max-xl:h-[62px] hover:scale-105 transition"
							>
								<img
									src={
										item?.name === 'Android'
											? '/icons/google-play-icon.svg'
											: '/icons/app-store-icon.svg'
									}
									className="object-contain"
									alt="App store"
								/>
							</a>
						))}
					</div>
				</div>
			</Section>
		</Section>
	);
}
